/*eslint-disable */
<template>
  <b-container fluid class="p-0 program_detail_model">
    <!-- Launch Modal for Add or Edit. In case of Add propProgramDetail is empty {} -->
    <b-modal v-if="showModal || editMode" v-model="showModal" size="lg"  :hideHeaderClose='true' :noCloseOnBackdrop="true" no-close-on-backdrop no-close-on-esc>
      <template #modal-header="">
        <h4>
          Entrance Exam and Test
        </h4>
        <b-button size="sm" class="closeEduModal" @click="CloseProgramModal()">
          <i class="fa-solid fa-xmark"></i>
        </b-button>
      </template>
      <b-row class="programTextContainer">
        <b-col md="12" class="programForm">
          <b-card p-0>
            <template v-slot:headerTitle>
              <h4 class="card-title">
                {{ cvCardTitle }}
              </h4>
            </template>
            <template>
              <div class="row w-100 m-0">
                <ValidationObserver ref="programForm" class="row w-100 m-0">
                  <div class="form-group col-12">
                    <label for="ExamSelect">Select Exam</label>
                    <ValidationProvider name="Select Exam"  v-slot="{ errors }" rules='required'>
                      <select v-model="vmProgramTest.exam_name" class="form-control mb-0" id="Select Exam">
                        <option v-for="(progTest, index) of ProgramAndTest" :key="(index+progTest)" :value="progTest.exam_name">
                          {{ progTest.exam_name }}
                        </option>
                      </select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div v-for="(progTest, index) of ProgramAndTest" :key="(index+progTest)" :value="progTest.exam_name" class="w-100 row">
                    <template v-if="vmProgramTest.exam_name === progTest.exam_name">
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12">
                        <label for="Exam Date">{{ progTest.exam_date_label }}<span class="primary-color">&nbsp;*</span></label>
                        <ValidationProvider name="Exam Date" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.exam_date" type="date" class="form-control mb-0" id="Exam_Date">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.subject_name_label">
                        <label for="Subject name">{{ progTest.subject_name_label }}<span class="primary-color">&nbsp;*</span></label>
                        <ValidationProvider name="Subject name" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.subject_name" type="text" class="form-control mb-0" id="subject_name">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.literacy_score_label">
                        <label for="Literacy Score">{{ progTest.literacy_score_label }}</label>
                        <ValidationProvider name="Literacy Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.literacy_score" type="number" class="form-control mb-0" id="Leading_Score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.reading_score_label">
                        <label for="Reading Score">{{ progTest.reading_score_label }}</label>
                        <ValidationProvider name="Reading Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.reading_score" type="number" class="form-control mb-0" id="Reading_Score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.conversation_score_label">
                        <label for="Conversation Name">{{ progTest.conversation_score_label }}</label>
                        <ValidationProvider name="Conversation" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.conversation_score" type="number" class="form-control mb-0" id="conversation_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.critical_reading_label">
                        <label for="Critical Reading">{{ progTest.critical_reading_label }}</label>
                        <ValidationProvider name="Critical Reading" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.critical_reading" type="number" class="form-control mb-0" id="Ccritical_reading">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.math_score_label">
                        <label for="Math Score">{{ progTest.math_score_label }}</label>
                        <ValidationProvider name="Math Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.math_score" type="number" class="form-control mb-0" id="Math">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.science_score_label">
                        <label for="Science Score">{{ progTest.science_score_label }}</label>
                        <ValidationProvider name="Science Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.science_score" type="number" class="form-control mb-0" id="science_core">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.english_score_label">
                        <label for="English score">{{progTest.english_score_label}}</label>
                        <ValidationProvider name="English score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.english_score" type="number" class="form-control mb-0" id="english_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.writing_score_label">
                        <label for="Writing Score">{{ progTest.writing_score_label }}</label>
                        <ValidationProvider name="Writing Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.writing_score" type="number" class="form-control mb-0" id="writing_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.evidence_based_reading_writing_score_label">
                        <label for="Evidence-Based Reading and Writing">{{ progTest.evidence_based_reading_writing_score_label }}</label>
                        <ValidationProvider name="Evidence-Based Reading and Writing" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.evidence_based_reading_writing_score" type="number" class="form-control mb-0" id="evidence_based_reading_writing_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.listening_score_label">
                        <label for="Listening">{{progTest.listening_score_label}}</label>
                        <ValidationProvider name="Listening"  v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.listening_score" type="number" class="form-control mb-0" id="listening_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.speaking_score_label">
                        <label for="Speaking">{{ progTest.speaking_score_label }}</label>
                        <ValidationProvider name="speaking" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.speaking_score" type="number" class="form-control mb-0" id="speaking_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.production_score_label">
                        <label for="Production score label">{{ progTest.production_score_label }}</label>
                        <ValidationProvider name="Production Score" v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.production_score" type="number" class="form-control mb-0" id="production_score">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>

                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.mathematics_1_score_label">
                        <label>{{ progTest.mathematics_1_score_label }}</label>
                        <input v-model="vmProgramTest.mathematics_1_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.biology_score_label">
                        <label>{{ progTest.biology_score_label }}</label>
                        <input v-model="vmProgramTest.biology_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.chemistry_score_label">
                        <label>{{ progTest.chemistry_score_label }}</label>
                        <input v-model="vmProgramTest.chemistry_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.physics_score_label">
                        <label>{{ progTest.physics_score_label }}</label>
                        <input v-model="vmProgramTest.physics_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.mathematics_2_score_label">
                        <label>{{ progTest.mathematics_2_score_label }}</label>
                        <input v-model="vmProgramTest.mathematics_2_score" type="number" class="form-control mb-0">
                      </div>

                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.mathematical_thinking_label">
                        <label>{{ progTest.mathematical_thinking_label }}</label>
                        <input v-model="vmProgramTest.mathematical_thinking_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.mathematical_reasoning_label">
                        <label>{{ progTest.mathematical_reasoning_label }}</label>
                        <input v-model="vmProgramTest.mathematical_reasoning_score" type="number" class="form-control mb-0">
                      </div>

                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.analytical_reasoning_label">
                        <label>{{ progTest.analytical_reasoning_label }}</label>
                        <input v-model="vmProgramTest.analytical_reasoning_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.quantitative_ability_label">
                        <label>{{ progTest.quantitative_ability_label }}</label>
                        <input v-model="vmProgramTest.quantitative_ability_score" type="number" class="form-control mb-0">
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.verbal_ability_label">
                        <label>{{ progTest.verbal_ability_label }}</label>
                        <input v-model="vmProgramTest.verbal_ability_score" type="number" class="form-control mb-0">
                      </div>

                      <div class="form-group col-md-4 col-sm-6 col-lg-4 col-xs-12" v-if="progTest.total_score_label">
                        <label for="Total Score">{{ progTest.total_score_label }}<span class="primary-color">&nbsp;*</span></label>
                        <ValidationProvider name="Total Score"  v-slot="{ errors }" rules='required'>
                          <input v-model="vmProgramTest.total_score" type="number" class="form-control mb-0" id="total_score" placeholder="Mandatory">
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </template>
                  </div>
                </ValidationObserver>
              </div>
            </template>
          </b-card>
        </b-col>
        <span class="pull-left primary-color">* Mandatory</span>
      </b-row>
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="CloseProgramModal()">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="addProgram()">
          Save
        </b-button>
      </template>
    </b-modal><!-- Launch Modal for Add or Edit. In case of Add propProgramDetail is empty {} -->

    <!-- Launched on the profile page to list all entrances. Should not be called in Modal Box during Add or Edit -->
    <template v-else-if="!showModal || editMode">
        <div class="row ml-2 programDetail  educationCard viewProgramCard pr-3">
          <div v-if="!propStudentScore" class="w-100">
             <h4 class="instituteTitle_block">
              <span><i class="fa-solid fa-angles-right primary-color font-size-16"></i>&nbsp;{{vmProgramTest.exam_name}}</span>
              <span class="educationAddIcon" @click="editProgramOpen()">
                <i class="fa-solid ri-pencil-line"></i>
              </span>
            </h4>

            <h6 class="mb-2"><span>Exam Date: {{vmProgramTest.exam_date | dateFormatDDMMYYYY}}<span class="primary-color">&nbsp;*</span></span></h6>
            <div v-for="(progTest, index) of ProgramAndTest" :key="(index)" class="w-100">
              <template v-if="vmProgramTest.exam_name === progTest.exam_name">
                <table class="examTable w-100 ml-0 pl-0 table_scroll">
                  <tr class="examTableHeaderRow" >
                    <th v-if="progTest.critical_reading_label">
                      <h6>{{ progTest.critical_reading_label }}</h6>
                    </th>
                    <th v-if="progTest.subject_name_label">
                      <h6>{{ progTest.subject_name_label }}</h6>
                    </th>
                    <th v-if="progTest.literacy_score_label">
                      <h6>{{ progTest.literacy_score_label }}</h6>
                    </th>
                    <th v-if="progTest.reading_score_label">
                      <h6>{{ progTest.reading_score_label }}</h6>
                    </th>
                    <th v-if="progTest.conversation_score_label">
                      <h6>{{ progTest.conversation_score_label }}</h6>
                    </th>
                    <th v-if="progTest.math_score_label">
                      <h6>{{ progTest.math_score_label }}</h6>
                    </th>
                    <th v-if="progTest.science_score_label">
                      <h6>{{ progTest.science_score_label }}</h6>
                    </th>
                    <th v-if="progTest.english_score_label">
                      <h6>{{progTest.english_score_label}}</h6>
                    </th>
                    <th v-if="progTest.writing_score_label">
                      <h6>{{progTest.writing_score_label}}</h6>
                    </th>
                    <th v-if="progTest.listening_score_label">
                      <h6>{{progTest.listening_score_label}}</h6>
                    </th>
                    <th v-if="progTest.speaking_score_label">
                      <h6>{{progTest.speaking_score_label}}</h6>
                    </th>
                    <th v-if="progTest.production_score_label">
                      <h6>{{progTest.production_score_label}}</h6>
                    </th>
                    <th v-if="progTest.mathematics_1_score_label">
                      <h6>{{ progTest.mathematics_1_score_label }}</h6>
                    </th>
                    <th v-if="progTest.biology_score_label">
                      <h6>{{ progTest.biology_score_label }}</h6>
                    </th>
                    <th v-if="progTest.chemistry_score_label">
                      <h6>{{ progTest.chemistry_score_label }}</h6>
                    </th>
                    <th v-if="progTest.physics_score_label">
                      <h6>{{ progTest.physics_score_label }}</h6>
                    </th>
                    <th v-if="progTest.mathematics_2_score_label">
                      <h6>{{ progTest.mathematics_2_score_label }}</h6>
                    </th>
                    <th v-if="progTest.mathematical_thinking_label">
                      <h6>{{ progTest.mathematical_thinking_label }}</h6>
                    </th>
                    <th v-if="progTest.mathematical_reasoning_label">
                      <h6>{{ progTest.mathematical_reasoning_label }}</h6>
                    </th>
                    <th v-if="progTest.analytical_reasoning_label">
                      <h6>{{ progTest.analytical_reasoning_label }}</h6>
                    </th>
                    <th v-if="progTest.quantitative_ability_label">
                      <h6>{{ progTest.quantitative_ability_label }}</h6>
                    </th>
                    <th v-if="progTest.verbal_ability_label">
                      <h6>{{ progTest.verbal_ability_label }}</h6>
                    </th>
                    <th v-if="progTest.total_score_label">
                      <h6>{{progTest.total_score_label}}</h6>
                    </th>
                    <th v-if="progTest.evidence_based_reading_writing_score_label">
                      <h6>{{progTest.evidence_based_reading_writing_score_label}}</h6>
                    </th>
                  </tr>
                  <tr>
                    <td v-if="progTest.critical_reading_label">
                      <p>
                        <span >{{vmProgramTest.critical_reading}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.subject_name_label">
                      <p>
                        <span >{{vmProgramTest.subject_name}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.literacy_score_label">
                      <p>
                        <span >{{vmProgramTest.literacy_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.reading_score_label">
                      <p>
                        <span >{{vmProgramTest.reading_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.conversation_score_label">
                      <p>
                        <span >{{vmProgramTest.conversation_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.math_score_label">
                      <p>
                        <span>{{vmProgramTest.math_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.science_score_label">
                      <p>
                        <span>{{vmProgramTest.science_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.english_score_label">
                      <p>
                        <span>{{vmProgramTest.english_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.writing_score_label">
                      <p>
                        <span>{{vmProgramTest.writing_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.listening_score_label">
                      <p>
                        <span>{{vmProgramTest.listening_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.speaking_score_label">
                      <p>
                        <span>{{vmProgramTest.speaking_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.production_score_label">
                      <p>
                        <span>{{vmProgramTest.production_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.mathematics_1_score_label">
                      <p><span>{{ vmProgramTest.mathematics_1_score }}</span></p>
                    </td>
                    <td v-if="progTest.biology_score_label">
                      <p><span>{{ vmProgramTest.biology_score }}</span></p>
                    </td>
                    <td v-if="progTest.chemistry_score_label">
                      <p><span>{{ vmProgramTest.chemistry_score }}</span></p>
                    </td>
                    <td v-if="progTest.physics_score_label">
                      <p><span>{{ vmProgramTest.physics_score }}</span></p>
                    </td>
                    <td v-if="progTest.mathematics_2_score_label">
                      <p><span>{{ vmProgramTest.mathematics_2_score }}</span></p>
                    </td>
                    <td v-if="progTest.mathematical_thinking_label">
                      <p><span>{{ vmProgramTest.mathematical_thinking_score }}</span></p>
                    </td>
                    <td v-if="progTest.mathematical_reasoning_label">
                      <p><span>{{ vmProgramTest.mathematical_reasoning_score }}</span></p>
                    </td>
                    <td v-if="progTest.analytical_reasoning_label">
                      <p><span>{{ vmProgramTest.analytical_reasoning_score }}</span></p>
                    </td>
                    <td v-if="progTest.quantitative_ability_label">
                      <p><span>{{ vmProgramTest.quantitative_ability_score }}</span></p>
                    </td>
                    <td v-if="progTest.verbal_ability_label">
                      <p><span>{{ vmProgramTest.verbal_ability_score }}</span></p>
                    </td>
                    <td v-if="progTest.total_score_label">
                      <p>
                        <span>{{vmProgramTest.total_score}}</span>
                      </p>
                    </td>
                    <td v-if="progTest.evidence_based_reading_writing_score_label">
                      <p>
                        <span>{{vmProgramTest.evidence_based_reading_writing_score}}</span>
                      </p>
                    </td>
                  </tr>
                </table>
              </template>
            </div>
          </div>
          <div class="w-100" v-else>
           <ul class="p-0">
              <li class="educationCard pt-2" style="font-weight: 400;">
                <span v-if="propStudentScore.exam_date">{{ propStudentScore.exam_date }} :- </span>
                {{ propStudentScore.exam_name }} |
                <span v-if="propStudentScore.subject_name">{{ propStudentScore.subject_name }} |</span>
                {{ propStudentScore.total_score }}
                <span class="educationAddIcon" @click="editProgramOpen(propStudentScore)">
                  <i class="fa-solid ri-pencil-line primary-color"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
    </template><!-- Launched on the profile page to list all entrances -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { User } from "../../FackApi/api/user.js"
import config from "../../Utils/config.js"
import ProgramAndTest from "../../FackApi/json/ProgramAndTest.json"

export default {
  name: "ProgramTest",
  props: {
    propProgramDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propUserView: {
      default: true,
      type: Boolean
    },
    propAdmId: {
      default: null
    },
    propGideUser: {
      type: Object
    },
    propShowEditBox: {
      type: Boolean,
      default: false
    },
    propStudentScore: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      vmProgramTest: {
      },
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Assessments & Exams",
      showModal: false,
      cvClassOptions: config.ClassList,
      editMode: false,
      ProgramAndTest: ProgramAndTest
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    if (this.$route.params.user_id) {
      this.gidUserId = this.$route.params.user_id
    }
    else {
      this.gidUserId = this.propGideUser && this.propGideUser.user_id ? this.propGideUser.user_id : this.userData.user_id
    }

    if (this.propProgramDetail) {
      this.vmProgramTest = { ...this.propProgramDetail }
    }

    // When opened from SPCM or anyother module, Dont show the edit modal of this component else 2 Modals will get displayed
    if (this.propOpenedInModal && !this.propShowEditBox) {
      // Open Modal in Add Mode
      this.showModal = true
      this.editMode = true
      this.editProgramOpen()
    }
    else if (this.propOpenedInModal && this.propShowEditBox) {
      // Open Modal in Edit Mode
      this.showModal = true
      this.editMode = true
    }
    else {
      // Dont Open Modal. View Mode
      this.showModal = false
      this.editMode = false
    }
  },
  methods: {
    /**
     * edit Program Open
     */
    editProgramOpen (score = null) {
      this.showModal = true
      this.editMode = true

      // If a score object is passed during an edit click, assign it to the form's local state
      if (score) {
        this.vmProgramTest = { ...score }
      }
      else if (this.propProgramDetail && Object.keys(this.propProgramDetail).length) {
        // Fallback to propProgramDetail if available
        this.vmProgramTest = { ...this.propProgramDetail }
      }
    },
    /**
     * addProgram
     */
    async addProgram () {
      const isValid = await this.$refs.programForm.validate()
      if (!isValid) {
        this.showToast = true
        this.toastMsg = "Please fill all mandatory fields correctly."
        this.toastVariant = "danger"
        return
      }

      if (!this.vmProgramTest.total_score || this.vmProgramTest.total_score == 0 || this.vmProgramTest.total_score == "0") {
        this.showToast = true
        this.toastMsg = "Test Score Cannot be Empty"
        this.toastVariant = "danger"
        return
      }

      let params = {
        user_program_test: JSON.stringify(this.vmProgramTest),
        gide_user_id: this.gidUserId
      }

      let userEditResp = await User.userProfileAddEdit(this, params)
      if (userEditResp.resp_status) {
        this.$emit("emitCloseProgramModal", userEditResp)
        this.editMode = false
        this.showModal = false
      }
    },
    /**
     * CloseProgramModal
     */
    CloseProgramModal () {
      this.editMode = false
      this.showModal = false
      this.vmProgramTest = {}
      this.$emit("emitCloseProgramModal", false)
    },
    syncFormWithProps () {
      const sourceData = this.propProgramDetail || this.propStudentScore
      if (sourceData && Object.keys(sourceData).length) {
        this.vmProgramTest = { ...sourceData }
      }
    }
  },
  watch: {
    propProgramDetail: "syncFormWithProps",
    propStudentScore: "syncFormWithProps"
  }
}
</script>
<style lang="scss">
input[type="number"], input[type="date"], input[type="text"]  {
  width: 100%;
}
.examTable {
  margin-left: 7px;
  .examTableHeaderRow {
    border-bottom: 1px solid var(--iq-border-light);
    height: 40px;
  }
}
.programTextContainer {
  .programForm {
    select {
        display: block;
        width: 100%;
        height: 33px;
        padding: 5px 25px 5px 5px;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.42857143;
        color: #555;
        background: 6px #efefef;
        border: 1px solid #ddd;
        border-radius: 0px;
        -moz-border-radius: 0px;
        -webkit-border-radius: 0px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    }
    .sub-ttl {
      font-size: 15px;
      margin-top: 0px;
      color: #0B446F;
      font-weight: 700;
      margin-bottom: 15px;
      line-height: 24px;
      width: 100%;
      span {
        text-transform: none;
        font-weight: 400;
        font-size: 13px;
        margin-left: 10px;
        color: #666;
      }
    }
    .radioCol {
      label {
        margin-left: 10px;
      }
    }
  }
  .resultAwait {
    input {
      margin-top: 31px;
      margin-right: 4px;
    }
  }
}
.programDetail {
  margin: 0;
  width: 100%;
  h4 {
    width: 100%;
    .educationAddIcon {
      float: right;
      color: var(--iq-primary);;
    }
  }
  input {
    border: none;
  }
  .cardHeader {
    padding-left: 13px;
    width: 100%;
  }
  hr {
    width: 100%;
  }
}
.viewProgramCard {
  box-shadow: none !important;
  .iq-card-body {
    padding-left: 0 !important;
    padding-top: 2px !important;
  }
}
.card-body{
  padding:0px;
}
.educationCard{
  position: relative;
}
</style>
